import {
    ButtonLayout,
    Callout,
    Circle,
    EmptyState,
    IconChatRegular,
    IconImportRegular,
    IconUserSupportRegular,
    IconWarningRegular,
    SnapCard,
    Spinner,
    Text2,
    Text3,
    Text8,
    NavigationBar,
    IconChevronLeftRegular,
    ThemeVariant,
    skinVars,
    IconInformationUserRegular,
    ButtonPrimary,
    Divider,
} from '@telefonica/mistica';
import React, { useEffect, useRef, useState } from 'react';
import { formatPrices } from '../../../utils/dataTransformation/unitsConversion';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { getBillDetail } from '../../../services/BillService';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getFormatDate } from '../../../utils/dataTransformation/dateConversions';
import navigateParams from '../../../utils/navigation/navigateParams';
import { AxiosError } from 'axios';
import { isBrowser } from 'react-device-detect';
import { IErrorGlobal } from '../../../utils/store/model/store.model';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';
import Stopper from '../../../components/Stopper';
import useUserlight from '../../../utils/hooks/useUserLight';
import SnackbarMessage from '../../../components/SnackbarMessage';
import useBillsHook from '../utils/hooks';
import BreadCrumbsWrapper from '../../../components/BreadcrumbsWrapper';

const BillDetail: React.FC = () => {
    let [params] = useSearchParams();
    const { t } = useTranslation();
    const isLight = useUserlight();
    const [loading, setLoading] = useState<boolean>(true);
    const navigateLoc = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const contactWhatsapp = process.env.REACT_APP_WEBVIEW_NUMBER_CONTACT_WHATSAPP as string;
    const buttonDownload = useRef<HTMLDivElement>(null);
    const buttonDownload1: any = document.getElementsByClassName('billDetail-page__header-buttons');
    const offsetTop: any = buttonDownload1[0]?.offsetTop;
    const topSticky: any = -offsetTop;
    const downloadRef = useRef<HTMLAnchorElement>(null);
    const billsDisabled = managementEnvironment().REACT_APP_STOPPER_BILLS_DISABLED;
    const [visible, setVisible] = useState(true);
    let [interactive, setInteractive] = useState('');
    let billId = params.get('id')!;
    let [amount, setAmount] = useState(0);
    let [idBill, setIdBill] = useState('');
    let [date, setDate] = useState('');
    let [debt, setDebt] = useState(null);
    let [documents, setDocuments] = useState([]);
    const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
    const { trackingUserInteraction } = new TrackingEvents();
    const { downloadPdf } = useBillsHook();

    const getInfoBillsDetails = () => {
        if (billId) {
            getBillDetail(billId)
                .then((response: any) => {
                    setInteractive(response.data.interactive);
                    setAmount(response.data.amount);
                    setIdBill(response.data.id);
                    setDebt(response.data.debt);
                    setDate(response.data.issueDate);
                    setDocuments(response.data.documents || []);
                    setLoading(false);
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    setLoading(false);
                });
        } else {
            const queryParams: IErrorGlobal = {
                pathname: '/bills',
                customRedirection: true,
                data: {
                    title: t('supportErrorProblemsTitle'),
                    localizedDescription: t('errorGenericDescription'),
                    id: '404',
                },
            };

            navigateLoc('/error', { state: queryParams });
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }

        const fetchData = async () => {
            await getInfoBillsDetails();
        };

        const handleScroll = () => {
            const heightCard = buttonDownload.current?.scrollHeight! - buttonDownload.current?.clientHeight!;
            const currentScrollY = window.scrollY;
            setVisible(heightCard + 1 > currentScrollY);
        };

        if (isLight) {
            setLoading(false);
        } else {
            fetchData();
        }

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isLight]);

    const sendToNative = (url: string, type: string, title: any) => {
        const queryParams = {};
        if (navigateParams(type, url, queryParams, title)) {
            window.open(url, '_blank');
        }
    };

    const calcTop = () => {
        if (!isNaN(topSticky) && isBrowser && window.innerWidth < 1024) {
            return topSticky + 40;
        } else if (!isNaN(topSticky) && isBrowser && window.innerWidth >= 1024 && window.innerWidth < 1220) {
            return topSticky + 60;
        } else {
            return topSticky | 0;
        }
    };

    const billDetail = () => {
        return (
            <>
                <div className='billDetail-page'>
                    <div
                        className='billDetail-page__header'
                        style={{
                            background: skinVars.colors.background,
                            top: calcTop(),
                            position: interactive && windowWidth >= 1024 ? 'static' : 'sticky',
                            padding: visible ? (windowWidth >= 1024 ? '0 0 32px' : '0 0 24px') : '8px 0',
                        }}
                    >
                        <div className='billDetail-page__header-data'>
                            {!(isWebviewAndroid || isWebviewIOS) && (
                                <>
                                    <div className='billDetail-page__mobile-navigationBar'>
                                        <NavigationBar
                                            withBorder={false}
                                            onBack={() => {
                                                navigateLoc(-1);
                                            }}
                                            title={t('breadcrumbsTitleBillDetail')}
                                        />
                                    </div>
                                    <div className='billDetail-page__mobile-return'>
                                        <div className='billDetail-page__mobile-return-cursor'>
                                            <div
                                                className='billDetail-page__mobile-return-icon'
                                                onClick={() => {
                                                    navigateLoc(-1);
                                                }}
                                            >
                                                <IconChevronLeftRegular color={skinVars.colors.textPrimary} size={20} />
                                            </div>
                                            <Text2 medium color={skinVars.colors.textPrimary}>
                                                {t('returnResponsive')}
                                            </Text2>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className='billDetail-page__mobile-breadcrumbs'>
                                <ThemeVariant>
                                    <BreadCrumbsWrapper
                                        title={t('breadcrumbsTitleBillDetail')}
                                        breadcrumbs={[{ url: '/bills', title: 'Facturas' }]}
                                    />
                                </ThemeVariant>
                            </div>
                            <div className='billDetail-page__header-date'>
                                <Text3 regular color={skinVars.colors.textPrimary}>
                                    {getFormatDate(date, 'DD MMMM YYYY')}
                                </Text3>
                            </div>
                            <div className='billDetail-page__header-amount'>
                                <Text8 color={skinVars.colors.textPrimary}>{formatPrices(amount, 'spent')}</Text8>
                            </div>
                            <div className='billDetail-page__header-billNumber'>
                                <Text3 regular color={skinVars.colors.textPrimary}>
                                    {t('billNumbre') + ` ${idBill}`}
                                </Text3>
                            </div>
                            <div
                                className='billDetail-page__header-buttons'
                                style={{ paddingTop: visible ? '0' : '8px' }}
                                ref={buttonDownload}
                            >
                                <ButtonLayout align='full-width'>
                                    <a
                                        ref={downloadRef}
                                        target={'_blank'}
                                        className='test-download'
                                        style={{ visibility: 'hidden', position: 'absolute' }}
                                    >
                                        {t('billDetailDownloadButton')}
                                    </a>
                                    <ButtonPrimary
                                        onPress={() => {
                                            trackingUserInteraction('download_bills_tapped');
                                            downloadPdf(idBill, downloadRef);
                                        }}
                                        StartIcon={IconImportRegular}
                                    >
                                        {t('billDetailDownloadButton')}
                                    </ButtonPrimary>
                                </ButtonLayout>
                            </div>
                        </div>
                        <div className='billDetail-page__header-clicked'>
                            <div
                                className={`${
                                    windowWidth >= 1024 ? 'visible' : visible ? 'visible' : 'hidden'
                                } billDetail-page__header-help`}
                            >
                                <SnapCard
                                    icon={
                                        <Circle size={40} backgroundColor={skinVars.colors.brandLow}>
                                            <IconChatRegular color={skinVars.colors.brand} />
                                        </Circle>
                                    }
                                    title={t('billsDebtWhatsappTitle')}
                                    subtitle={t('billsDebtWhatsappDescription')}
                                    onPress={() => {
                                        trackingUserInteraction('whatsapp_info_tapped');
                                        sendToNative(`https://wa.me/${contactWhatsapp}`, 'modeExternal', '');
                                    }}
                                />
                                <SnapCard
                                    icon={
                                        <Circle size={40} backgroundColor={skinVars.colors.brandLow}>
                                            <IconUserSupportRegular color={skinVars.colors.brand} />
                                        </Circle>
                                    }
                                    title={t('billsDebtSupportTitle')}
                                    subtitle={t('billsDebtSupportDescription')}
                                    onPress={() => {
                                        trackingUserInteraction('help_tapped');
                                        sendToNative('https://o2online.es/ayuda/facturacion/', 'modeExternal', '');
                                    }}
                                />
                            </div>
                            {debt && (
                                <div
                                    className='billDetail-page__header-callout'
                                    style={{
                                        padding: visible
                                            ? windowWidth >= 768
                                                ? '16px 32px 0'
                                                : '16px 16px 0'
                                            : windowWidth >= 768
                                            ? '0 32px 16px'
                                            : '0 16px 16px',
                                    }}
                                >
                                    <Callout
                                        icon={<IconWarningRegular color={skinVars.colors.error} size={24} />}
                                        description={t('billDetailCalloutDescription')}
                                    ></Callout>
                                </div>
                            )}
                            {amount < 0 && (
                                <div
                                    className='billDetail-page__header-callout'
                                    style={{
                                        padding: visible
                                            ? windowWidth >= 768
                                                ? '16px 32px 0'
                                                : '16px 16px 0'
                                            : windowWidth >= 768
                                            ? '0 32px 16px'
                                            : '0 16px 16px',
                                    }}
                                >
                                    <Callout
                                        icon={<IconInformationUserRegular color={skinVars.colors.brand} size={24} />}
                                        description={t('billDetailPassCalloutDescription')}
                                    ></Callout>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='billDetail-page__divider'>
                        <Divider />
                    </div>
                    {interactive ? (
                        <iframe srcDoc={interactive} width='100%' style={{ height: '100%' }}></iframe>
                    ) : (
                        <div className='billDetail-page__emptyState'>
                            <EmptyState
                                icon={<IconImportRegular color={skinVars.colors.brand} size={64} />}
                                title={t('emptyStateNoBillDetailTitle')}
                            ></EmptyState>
                        </div>
                    )}
                </div>
            </>
        );
    };

    if (isLight) {
        return <SnackbarMessage url='/bills' timeout={3000} />;
    }

    return !billsDisabled ? (
        <>
            {loading ? (
                <div className='c-spinner'>
                    <Spinner size={24} />
                    <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
                </div>
            ) : (
                billDetail()
            )}
        </>
    ) : (
        <Stopper></Stopper>
    );
};

export default BillDetail;
